import { api } from '../client';
import type { AuthUser } from '@/stores/auth';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface OAuthCallbackRequest {
  code: string;
  state?: string;
  redirect_uri?: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  display_name: string;
}

export interface SessionTokens {
  access_token: string;
  refresh_token: string;
  user: AuthUser;
}

export interface SessionInfo {
  id: string;
  device_info?: { type?: string; os?: string; browser?: string } | null;
  ip_address?: string | null;
  last_activity_at: string;
  created_at: string;
  current: boolean;
}

export const authApi = {
  register: (body: RegisterRequest) =>
    api.post<SessionTokens>('/auth/register', body),

  login: (body: LoginRequest) => api.post<SessionTokens>('/auth/login', body),

  refresh: (refresh_token: string) =>
    api.post<SessionTokens>('/auth/refresh', { refresh_token }),

  logout: (refresh_token: string) =>
    api.post<{ success: boolean }>('/auth/logout', { refresh_token }),

  forgotPassword: (email: string) =>
    api.post<void>('/auth/forgot-password', { email }),

  resetPassword: (token: string, password: string) =>
    api.post<void>('/auth/reset-password', { token, password }),

  oauthGoogle: (body: OAuthCallbackRequest) =>
    api.post<SessionTokens>('/auth/oauth/google', body),

  oauthGithub: (body: OAuthCallbackRequest) =>
    api.post<SessionTokens>('/auth/oauth/github', body),

  listSessions: () => api.get<SessionInfo[]>('/auth/sessions'),

  revokeSession: (id: string) => api.delete<void>(`/auth/sessions/${id}`),

  revokeAllSessions: () => api.post<void>('/auth/sessions/revoke-all'),

  me: () => api.get<AuthUser>('/users/me'),
};
